import React from 'react'
import { Card } from 'primereact/card'
import { TabPanel } from 'primereact/tabview'

import { PageLayoutContainer } from '../../../lib/page-layout-container'
import { LazyTabView } from '../../../common/uikit/LazyTabView'
import { CompanyTransfersWidget } from '../../../common/components/company-transfers-widget/company-transfers-widget'
import useText from '../../../common/hooks/useText'

export const TransfersPage = () => {
    const text = useText()

    return (
        <PageLayoutContainer>
            <Card title={text('lblChangesOfChargingOperator')}>
                <LazyTabView>
                    <TabPanel header={text('lblPendingRequests')}>
                        <CompanyTransfersWidget />
                    </TabPanel>
                </LazyTabView>
            </Card>
        </PageLayoutContainer>
    )
}
